import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";

import "./nujobsdashboardmatchingjobs.scss";

import { Card, Statistic } from "antd";

import {
  EnvironmentOutlined,
  ClockCircleOutlined,
  DollarOutlined,
  ThunderboltOutlined
} from "@ant-design/icons";
import useNuJobDetailsStore from "../../../store/nujobsdetails.store";
import useNuJobsStore from "../../../store/nujobs.store";

function NuJobsMatchingJobs() {

  const navigate = useNavigate();
  const { nujobsSkillsBasedsJds,skilledBasedJobs,SkillResponseMetadata } = useNuJobDetailsStore(); 
  const { setSearchMetaData } = useNuJobsStore();   

  function formatUnixDate(ts) {
      const d = new Date(ts * 1000);
      const mm = String(d.getMonth() + 1).padStart(2, "0");
      const dd = String(d.getDate()).padStart(2, "0");
      const yyyy = d.getFullYear();

      return `${dd}-${mm}-${yyyy}`;
  }   
  const encodeJson = () =>{
        let encodedJsonValues ={};
        encodedJsonValues.keywords= "";
        encodedJsonValues.city=null;
        encodedJsonValues.category=[];  
        encodedJsonValues.timestamp= 0;  
        encodedJsonValues.postingdate= "All"
        encodedJsonValues.pagenum= 1;
        encodedJsonValues.maxPerPage= 10;

        //from values
        encodedJsonValues.minexp=null;
        encodedJsonValues.maxexp=null;  
        encodedJsonValues.minctc= null;  
        encodedJsonValues.maxctc= null
        encodedJsonValues.noticeperiod= []; 
        encodedJsonValues.postingdate=[];
        encodedJsonValues.workmode=null;  
        encodedJsonValues.diversity= null;  
        encodedJsonValues.role= []
        encodedJsonValues.roletype= []
        encodedJsonValues.companytype= null
        encodedJsonValues.jobfor= null                        
        return encodedJsonValues
    }
  
  useEffect(() => {
    const jasonValues = encodeJson()
    nujobsSkillsBasedsJds(jasonValues,null)
  }, []);


  const jobsData =
    skilledBasedJobs?.map((job, idx) => ({
      id: idx + 1,
      jdId:job?.QhCompanyJID,
      title: job?.JDDetails.Title,
      location:job?.JDRequired.WorkLocation[0],
      role: job?.JDRequired?.role,
      salary: job?.JDProject.MinCtc + " - "+job?.JDProject.MaxCtc + " LPA",
      experience:job?.JDRequired.MinExperience + " - " + job?.JDRequired.MaxExperience + " Yrs",
      keywords: job?.JDRequired.kwarray,
      companyName: job?.JDClient.ClientName,
      AddedOn: formatUnixDate(job?.timestamp),
    })) || [];

  const jdHandler = (id) => {
    var str = "skills"
    navigate(`/nujobshome/nujobsViewJobsContainer/${str}/${id}`);
  };

  const handleViewMoreClick = () => {
    setSearchMetaData(SkillResponseMetadata)
    navigate("/nujobshome/nujobsSkillsMatchingSearchResults");
  }
  return (
    <div className="nujobsdashboardmatchingjobs-wrapper">
    <div className="matching-jobs-section">
      <div className="section-header">
        <div>
          <h3>Jobs Matching Your Profile</h3>
          <span>
            Personalized recommendations based on your skills
          </span>
        </div>
          {jobsData.length > 2 && (
            <div
              className="view-all-link"
              onClick={handleViewMoreClick}
            >
              View All →
            </div>
          )}        
          </div>

      <div className="matching-jobs-grid">
        {jobsData.slice(0, 2).map((job,idx) => (

          <div className="matching-job-card" key={job.id}>
            {/* TOP */}
            <div className="job-card-top">

              <div>
                <div className="job-title">
                  {job.title}
                </div>

                <div className="company-name">
                  {job.company}
                </div>
              </div>

              <div className="match-badge">
                <ThunderboltOutlined />
                {job.match}
              </div>

            </div>

            {/* META */}
            <div className="job-meta">

              <div className="meta-item">
                <EnvironmentOutlined />
                {job.location}
              </div>

              <div className="meta-item">
                <ClockCircleOutlined />
                {job.experience}
              </div>

              <div className="meta-item">
                <DollarOutlined />
                {job.salary}
              </div>

            </div>

            {/* SKILLS */}
            <div className="job-skills">
              <div className="skill-tag">{job.keywords?.[0]}</div>
              <div className="skill-tag">JavaScript</div>
            </div>

            {/* FOOTER */}
            <div className="job-footer">

              <div className="match-text">
                Strong profile match
              </div>

              <button className="view-job-btn" onClick={()=>jdHandler(job.jdId)}>
                View Job
              </button>

            </div>

          </div>
        ))}
      </div>

    </div>

    </div>
  );
}

export default NuJobsMatchingJobs;